import classes from './Card.module.css';

interface ICardProps {
    children: JSX.Element;
    fullWidth?: boolean;
    adminTable?: boolean;
}

const Card: React.FC<ICardProps> = ({ children, fullWidth = false, adminTable = false }) => {
    return <div className={`${classes.card} ${fullWidth && classes['full-width']} ${adminTable && classes['adminTableCustom']}`}>{children}</div>;
};

export default Card;
